import { combineReducers } from '@reduxjs/toolkit';

import { apartments } from './apartments';
import { engineeringNetworks } from './engineeringNetworks';

import { myCallsSlice } from './myCallsSlice';

export const calls = combineReducers({
  apartments,
  engineeringNetworks,
  myCalls: myCallsSlice.reducer,
});
